function escapeSpecialChars(str = '') {
  return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export default escapeSpecialChars;
